import "./Synonyms.css";

export default function Synonyms(props) {
    if (props.synonyms) {
        return (
           <div className="Wrap">
         <span>Similar:</span>
            <ul className="Synonyms" >
            {props.synonyms.map(function(synonym, index) {
            return (<li key={index}>{synonym}</li>)})}
        </ul>
  
        </div>
    )} else {
        return null;
    }
}